var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2400517_analysis_analytics_inflation_report_statistics_icon",
    "data-name": "2400517_analysis_analytics_inflation_report_statistics_icon",
    transform: "translate(-6.275 -6.275)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(6.275 6.275)",
    fill: "#ed5565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(15.82 16.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_65_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_71_",
    d: "M148.3,142.2l-6.564.972,1.736,2.175-3.695,3.178a.069.069,0,0,1-.108-.015l-1.936-2.461.008-.008-.309-.417a.6.6,0,0,0-.864-.108l-5.569,4.6.015.015c.262.27.517.548.779.825l5-4.119a.07.07,0,0,1,.108.015l2.592,3.286a.076.076,0,0,0,.108.015l.023.031,4.551-3.911a.008.008,0,0,0,.008-.008l1.682,2.121Z",
    transform: "translate(-131 -142.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_66_",
    d: "M162.835,250.3l-6.919,1.026,1.82,2.291-3.888,3.348a.078.078,0,0,1-.116-.015l-2.044-2.584.008-.008-.324-.44a.622.622,0,0,0-.9-.116l-5.87,4.837c.008.008.015.008.015.015.27.293.548.579.825.864l5.276-4.343a.078.078,0,0,1,.116.015l2.731,3.463a.085.085,0,0,0,.116.015l.023.031,4.8-4.119a.008.008,0,0,0,.008-.008l1.782,2.237Z",
    transform: "translate(-143.551 -241.961)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.6910566be25b738c9c7f5c8a7de09ff2.svg";
export { ForwardRef as ReactComponent };